<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="ts-border-solid ts-border-gray-300 ts-border ts-rounded ts-rounded-t-none ts-border-t-0 ts-p-3"
        >
          <div class="auto-overflow">
            <div>
              <table class="table-detail">
                <thead>
                  <tr>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      {{ $t('gameSetting.no') }}
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      {{ $t('gameSetting.gameLot') }}
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      {{ $t('gameSetting.unitPrice') }}
                    </th>
                    <th
                      class="ts-px-2 ts-py-2 ts-bg-gray-400"
                      v-if="!sixFortyNine"
                    >
                      {{ $t('gameSetting.maxBettingAmount') }}
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      <span v-if="sixFortyNine">{{
                        $t('gameSetting.payoutAmount')
                      }}</span>
                      <span v-else>{{ $t('gameSetting.payoutOdd') }}</span>
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400" v-if="!fiveD">
                      {{ $t('gameSetting.splitPrice') }}
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      {{ $t('gameSetting.order') }}
                    </th>
                    <th class="ts-px-2 ts-py-2 ts-bg-gray-400">
                      {{ $t('gameSetting.name') }}
                    </th>
                    <th
                      class="ts-px-2 ts-py-2 ts-bg-gray-400 ts-text-center ts-w-8"
                      v-if="fiveD"
                    >
                      <span
                        class="float-button ts-bg-blue-500 ts-p ts-rounded ts-px-2 ts-text-white"
                      >
                        <a href="#" @click.prevent="addRow"
                          ><i
                            class="fas fa-plus ts-fill-current ts-text-white"
                          ></i
                        ></a>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(detail, index) in model.details" :key="index">
                    <td valign="middle" style="width:10px">
                      <p class="ts-pt-2 ts-my-auto">{{ index + 1 }}</p>
                    </td>

                    <template v-if="sixFortyNine">
                      <td
                        valign="middle"
                        style="width:10px"
                        class="ts-whitespace-no-wrap"
                      >
                        <ts-checkbox
                          :value="6 - index"
                          v-model="detail.digit_taken"
                          >{{
                            6 - index == 6 ? 'Jackpot' : 6 - index + ' Number'
                          }}</ts-checkbox
                        >
                      </td>
                    </template>

                    <template v-if="fiveD">
                      <td
                        valign="middle"
                        style="width:10px"
                        class="ts-whitespace-no-wrap"
                      >
                        <div
                          class="ts-inline-block"
                          v-for="(item, index) in 5"
                          :key="index"
                        >
                          <ts-checkbox
                            :value="index"
                            v-model="detail.digit_taken"
                          ></ts-checkbox>
                        </div>
                      </td>
                    </template>
                    <td>
                      <input
                        type="number"
                        class="ts-pt-2 bb"
                        v-model.number="detail.unit_price"
                      />
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.unit_price')"
                      >
                        {{ errors.first('details.' + index + '.unit_price') }}
                      </div>
                    </td>
                    <td v-if="!sixFortyNine">
                      <input
                        type="number"
                        class="ts-pt-2 bb"
                        v-model.number="detail.max_betting_amount"
                      />
                      <div
                        class="validate"
                        v-if="
                          errors.has('details.' + index + '.max_betting_amount')
                        "
                      >
                        {{
                          errors.first(
                            'details.' + index + '.max_betting_amount'
                          )
                        }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="ts-pt-2 bb"
                        v-model.number="detail.odds"
                      />
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.odds')"
                      >
                        {{ errors.first('details.' + index + '.odds') }}
                      </div>
                    </td>
                    <td v-if="!fiveD">
                      <ts-checkbox
                        name="split_price"
                        v-model="detail.split_price"
                        @change="checkboxChange(detail)"
                        >{{ $t('gameSetting.splitPrice') }}</ts-checkbox
                      >
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.split_price')"
                      >
                        {{ errors.first('details.' + index + '.split_price') }}
                      </div>
                    </td>
                    <td>
                      <input
                        v-if="fiveD"
                        type="number"
                        class="ts-pt-2 bb"
                        v-model.trim="detail.channel_order"
                      />
                      <input
                        v-if="sixFortyNine"
                        type="number"
                        class="ts-pt-2 bb ts-w-1"
                        readonly
                        :value="(detail.channel_order = index + 1)"
                      />
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.channel_order')"
                      >
                        {{
                          errors.first('details.' + index + '.channel_order')
                        }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="ts-pt-2 bb"
                        v-model.trim="detail.game_lot_name"
                      />
                      <div
                        class="validate"
                        v-if="errors.has('details.' + index + '.game_lot_name')"
                      >
                        {{
                          errors.first('details.' + index + '.game_lot_name')
                        }}
                      </div>
                    </td>
                    <td v-if="fiveD" class="ts-text-center">
                      <a
                        href=""
                        class="text-red ts-pt-2"
                        v-if="index > 0"
                        @click.prevent="removeRow(index)"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'gameSettingDetailSetup',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      rows: {
        game_lot_id: 0,
        // game_setting_id: null,
        game_lot_name: null,
        unit_price: null,
        max_betting_amount: null,
        odds: null,
        channel_order: null,
        split_price: false,
        digit_taken: []
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    fiveD() {
      return this.model.game_type_id == 2
    },
    sixFortyNine() {
      return this.model.game_type_id == 1
    },
    isEdit() {
      let checking = _.isEmpty(this.$store.state.administrator.gameSetting.edit_data)
      return !checking;
    }
  },
  methods: {
    addRow() {
      this.model.details.push(Object.assign({}, this.rows))
    },
    removeRow(index) {
      this.model.details.splice(index, 1)
    },
    createFiveDFirstRow() {
      let newRow = Object.assign({}, this.rows)
      newRow.digit_taken = [0, 1, 2, 3, 4]
      this.model.details.push(Object.assign({}, newRow))
    },
    createSixFortyNine() {
      let newRow = Object.assign({}, this.rows)
      for (let i = 1; i <= 6; i++) {
        newRow.channel_order = i
        this.model.details.push(Object.assign({}, newRow))
      }
    },
    checkboxChange(detail) {
      this.model.details.forEach(el => {
        el.split_price = false
      })
      detail.split_price = true
    }
  },
  watch: {
    'model.game_type_id': function(value) {
      if (!this.isEdit) {
        this.model.details = []
        if (value == 2) {
          this.createFiveDFirstRow()
        } else if (value == 1) {
          this.createSixFortyNine()
          this.model.details[0].digit_taken = [6]
        }
      }
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.table-detail {
  width: 100%;
  min-width: 500px;
}
.table-detail td {
  padding: 3px 7px;
  width: fit-content;
}
.bb {
  border-bottom: 1px solid #d3d8de;
  width: 100%;
  outline: none;
}
</style>
